import React from 'react';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from '../../actions/customer';
import { default as Config } from '../../config';

import { Link } from '../../components/router/link';
import DataGrid from 'react-datagrid';

const statuses = {
	1: 'Nowe',
	2: 'Na produkcji',
	3: 'Zrealizowane'
};

let columns = [
	{ name: 'nr', 'title': 'Nr. zlecenia', width: 100, textAlign: 'center', render: function(nr, data){
		return (
			<div>{nr}{data.discount ? <i className="gift icon purple"></i> : ''}</div>
		);
	}},
	{ name: 'delivery_date', 'title': 'Data dostawy', textAlign: 'center'},
	{ name: 'created_at', 'title': 'Data złożenia', textAlign: 'center'},
	{ name: 'status', 'title': 'Status',textAlign: 'center', width: 130, render: function(status){
		let color;
		if(status == 1)
			color = 'green';
		else if(status == 2)
			color = 'orange';
		else
			color = 'blue';

		return (
			<div className={ "ui button "+color }>{statuses[status]}</div>
		);
	}},
	{ name: 'm2', 'title': 'm2', textAlign: 'center', width:100 },
	{ name: 'sumPrice', 'title': 'Cena netto', textAlign: 'center', width:100, render: function(price){
		return (<div>{price+' zł'}</div>);
	}},
	{ name: 'damaged', 'title': 'Uszkodzenia', textAlign: 'center', width: 130, render: function(damaged, data){
		let className, title;
		if(damaged > 0){
			className = 'remove red';
			title = 'Uszkodzone '+damaged;
		}
		else{
			className = 'chevron down green';
			title = 'Brak uszkodzeń';
		}

		if(data.status == 1){
			className = 'info blue';
			title = 'Zlecenie jeszcze nie trafiło na produkcję';
		}

		return (
			<i title={title} className={ 'icon circle '+className }></i>
		);
	}},
	{ name: 'id', 'title': 'Operacje', textAlign: 'center', width: 100, render: function(id, data){
		let edit = '';
		if(data.status == 1)
			edit = 
				<Link pathname="customer/order/update" query={{id: id}}>
					<a title="Aktualizuj">
						<i className="edit icon"></i>
					</a>
				</Link>
			;
		else 
			edit = ( <i className="ban icon red"></i> );

		return 	(
			<div>
				<Link pathname="customer/order/view" query={{id: id}}>
					<a title="Zobacz szczegóły">
						<i className="eye icon"></i>
					</a>
				</Link>
				{edit}
				<a href="" onClick={(event) => {
					event.preventDefault(); 
					window.open(Config.apiUrl+'customer/generate-protocol/'+id+'?access-token='+localStorage.getItem('token'));
				}} title="Generuj protokół">
					<i className="file icon"></i>
				</a>				
			</div>
		);
	}}
];

export let CustomerOrder = React.createClass({
	displayName: 'CustomerOrder',
	render: function(){
		return (<div className="">
			<div className="">
				<h2 className=""> Lista zleceń</h2>
				<Link pathname="customer/order/create">
					<button className="ui green button">Dodaj nowe zlecenie</button>
				</Link>
				<br /><br />
				<DataGrid idProperty="id" dataSource={this.props.actions.fetchOrders} columns={columns} />
			</div>
		</div>);
	}
});

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  actions : bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomerOrder);


/** WEBPACK FOOTER **
 ** ./js/views/customer/Order.js
 **/